import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    let opts = this.getDefaultParams();
    let data = $(this.element).data()

    // https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
    if (data.fixParent) {
      opts.dropdownParent = String(data.fixParent) == 'true' ? this.element.parentNode : $(data.fixParent);
    }

    $(this.element).select2(opts);
  }

  getDefaultParams() {
    return {
      width: '100%'
    };
  }

  disconnect() {
    $(this.element).select2('destroy');
  }
}
